export default "__VITE_ASSET__DDUj6F4$__";